<div>
    <div class="navigation-preview" [class.expanded]="nav.expanded()">
      <!------- extension slides (grid row 2, columns 1-3, or 2-4 when the nav is on the left): ------->
      <pcp-nav-extension-slides-row
        class="extension-row"
        [slides]="nav.extensionSlides()"
        [previewIdx]="nav.extensionSlidePreviewIdx()"
        [currentSlideIdx]="nav.currentExtensionSlideIndex()"
        [visible]="nav.extensionSlidesNavigationVisible()"
        [previousEnabled]="nav.extensionPreviewPreviousEnabled()"
        [nextEnabled]="nav.extensionPreviewNextEnabled()"
        [visibleCount]="nav.visibleCount"
        (slideClicked)="nav.slideClicked($event)"
        (previousClicked)="nav.extensionPrevious()"
        (nextClicked)="nav.extensionNext()"
        (previewIdxChange)="nav.extensionPreviewIdxChanged($event)"
      />

      <!------- basic slides (grid row 4, columns 1-3, or 2-4 when the nav is on the left): ------->
      <pcp-nav-basic-slides-row
        class="basic-row"
        [slides]="nav.basicSlides() ?? []"
        [slideIdx]="nav.basicSlideIdx()"
        [currentSlideIdx]="nav.currentBasicSlideIdx()"
        [visible]="nav.showBasicSlidesPreview()"
        [visibleCount]="nav.visibleCount"
        (slideClicked)="nav.slideClicked($event)"
        (previousClicked)="nav.basicPrevious()"
        (nextClicked)="nav.basicNext()"
        (swiped)="nav.basicSwiped($event)"
      />

      <!------- floating toolbar, default place (nothing saved): a 0-wide cell in the glass column, row 1, level with
               its open button, 50px outside the glass. Pure CSS: follows the button on switch / resize / rows toggle. ------->
      @if (showFloatingToolbar() && !savedToolbarPosition()) {
        <div class="floating-toolbar-anchor">
          <ng-container [ngTemplateOutlet]="floatingToolbar" [ngTemplateOutletContext]="{ $implicit: side() }" />
        </div>
      }

      <!------- nav toolbar: the glass column (grid column 4, or 1 when the nav is on the left; all rows) ------->
      <div class="nav-toolbar">
        <!-- row 1: action buttons -->
        @if (hasSomeActionButton()) {
          <div class="actions">
            <pcp-nav-action-buttons
              [difficultQuestionNumbers]="nav.difficultQuestionNumbers()"
              [assignedDriverscamVideo]="nav.assignedDriverscamVideo()"
              (difficultQuestionIndicatorClicked)="nav.difficultQuestionIndicatorClicked($event)"
              (driverscamAssignmentClicked)="nav.driverscamAssignmentClicked($event)"
            />
            @if (showFloatingToolbar()) {
              <button
                mat-icon-button
                pcp-ui-icon-button size="large"
                class="floating-toolbar-open-button"
                [class.active]="isFloatingToolbarOpened()"
                [attr.aria-pressed]="isFloatingToolbarOpened()"
                (click)="onToggleFloatingToolbar()"
                [matTooltip]="'icon-button.drawing-tool' | transloco"
                [attr.aria-label]="'icon-button.drawing-tool' | transloco"
                >
                <mat-icon svgIcon="pcp-toolbar"></mat-icon>
              </button>
            }
          </div>
        }

        <!-- row 2: extension slides toggle (level with the extension thumbnails) -->
        <pcp-nav-extension-toggle
          class="extension-row"
          [shown]="nav.showExtensionSlidesPreview()"
          [hasSlides]="nav.hasExtensionSlides()"
          (toggled)="nav.extensionToggled($event)"
        />

        <!-- row 4: basic slides toggle (level with the basic thumbnails) -->
        <pcp-nav-basic-toggle
          class="basic-row"
          [shown]="nav.showBasicSlidesPreview()"
          (toggled)="nav.basicToggled($event)"
        />

        <!-- row 5: separator -->
        <div class="grid-cell separator-cell">
          <div class="separator"></div>
        </div>

        <!-- row 6: switch (nav side left ⇄ right) -->
        <div class="grid-cell switch">
          <button
            mat-icon-button
            [matTooltip]="'icon-button.switch' | transloco"
            [attr.aria-label]="'icon-button.switch' | transloco"
            [attr.aria-pressed]="side() === 'left'"
            (click)="toggleSide()"
            size="medium"
            >
            <mat-icon svgIcon="pcp-switch"></mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!------- floating drawing toolbar: rendered in ONE of two places (default cell above, or saved layer below) ------->
    <!-- not visible; the "frame": drag boundary + measuring box (exactly the visible window). Top level (not inside
         an @if), so the template below can read the #floatingToolbarBoundary reference from both places. -->
    <div #floatingToolbarBoundary class="floating-toolbar-boundary"></div>

    <ng-template #floatingToolbar let-layoutKey>
      <pcp-slide-sync-floating-toolbar
        [boundary]="floatingToolbarBoundary"
        [layoutKey]="layoutKey"
        [class.hidden]="!isFloatingToolbarOpened()"
        >
        <!-- the beamer's floating-toolbar buttons; inside the template, so they can move between the two places -->
        <ng-content select="[floating-toolbar-content]"></ng-content>
      </pcp-slide-sync-floating-toolbar>
    </ng-template>

    <!-- saved place: fixed layer, a point counted from the window's bottom-right corner -->
    @if (showFloatingToolbar() && savedToolbarPosition(); as saved) {
      <div
        class="floating-toolbar-layer"
        [style.left]="'calc(100% - ' + saved.right + 'px)'"
        [style.top]="'calc(100% - ' + saved.bottom + 'px)'"
        >
        <ng-container [ngTemplateOutlet]="floatingToolbar" [ngTemplateOutletContext]="{ $implicit: saved }" />
      </div>
    }
</div>
